import { FC } from 'react';
import CommonPage from '../components/page/CommonPage';
import TerminalImport from "../components/terminal/TerminalImport";
import { PageTitle } from "../components/common/PageTitle";


const DeviceImportPage : FC= () => {
  return (
    <CommonPage selectBtnIndex={2}>
      <PageTitle title="端末インポート" />
      <TerminalImport />
    </CommonPage>
  );
};

export default DeviceImportPage;